import { useSearchParams } from 'react-router-dom';

import { cn } from '@/shared/utils';

import Sort from '@/components/SortOptions';
import AdvertisementBanner from '@/components/home/banner/AdvertisementBanner';
import BcList from '@/components/home/bcList';
import LocationPermissionUI from '@/components/home/locationPermissionUI';
import RecentlyViewed from '@/components/home/recentlyList';
import SwedishLeague from '@/components/home/swedishLeague';
import SearchInput from '@/components/ui/searchInput';
import useHome from '@/hooks/home/useHome';
import { EVENTS, TrackEvent, useTrackPageView } from '@/services/track';

const Home = () => {
  const [searchParams] = useSearchParams();
  const showSwedishLeague =
    searchParams.get('panel')?.toLowerCase() === 'swedish-league';

  const {
    searchTerm,
    orderCriteria,
    bowlingCenters,
    sortOptionsRef,
    showPermissionUi,
    locationPermissionDenied,
    onRequestPermission,
    onSort,
    onSearch,
  } = useHome();

  useTrackPageView();

  return (
    <>
      <section
        className="h-[calc(100vh/5)] overflow-hidden"
        data-cy="top-banner"
      >
        <a
          href="https://youtu.be/lpXkSn-npXQ"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            TrackEvent(EVENTS.BANNER_CLICK, {
              position: 'top',
            })
          }
        >
          <img
            src="/images/banner.png"
            alt="Lanetalk banner"
            className="w-full h-full object-contain"
          />
        </a>
      </section>

      <section className="pt-4 max-w-[1400px] mx-auto px-4">
        <div className="flex flex-col gap-6 md:flex-row md:flex-wrap pb-8">
          <div className="w-full md:flex-1 md:min-w-[400px]">
            <div
              className={cn(
                'mb-4 sticky top-[107px] md:top-navbar-desktop backdrop-blur-md z-10'
              )}
            >
              <SearchInput
                onChange={(e) => onSearch(e.target.value)}
                value={searchTerm}
                data-cy="search-input"
              />
            </div>
            <h3 className="text-xl">Bowling Centers</h3>

            <RecentlyViewed />

            <div
              className="sticky backdrop-blur-md pb-4 pt-4 z-10 top-[calc(107px+3.5rem)] md:top-[calc(theme(spacing.navbar-desktop)+3.5rem)]"
              ref={sortOptionsRef}
            >
              <Sort value={orderCriteria} onChange={onSort} />
            </div>
            {showPermissionUi ? (
              <LocationPermissionUI
                onRequestPermission={onRequestPermission}
                permissionDenied={locationPermissionDenied}
              />
            ) : (
              <BcList {...bowlingCenters} searchTerm={searchTerm} />
            )}
          </div>
          <aside className="w-full md:w-[512px] md:flex-shrink-0 sticky top-navbar-desktop h-[calc(100vh-117px)] md:h-[calc(100vh-65px)]">
            {showSwedishLeague ? <SwedishLeague /> : <AdvertisementBanner />}
          </aside>
        </div>
      </section>
    </>
  );
};

export default Home;
